import { useState } from "react";
import { Loader2 } from "lucide-react";
import { MEDIA_FOLDERS, type MediaFolder } from "@ckgo2/shared/types";

/** Pick a type-category folder to move the selected media into. */
export default function MoveFolderModal({
  count,
  onClose,
  onMove,
  pending,
}: {
  count: number;
  onClose: () => void;
  onMove: (folder: MediaFolder) => void;
  pending: boolean;
}) {
  const [target, setTarget] = useState<MediaFolder>("general");
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-sm rounded-xl bg-white p-4 shadow-xl dark:bg-gray-900">
        <h3 className="mb-3 text-lg font-semibold text-gray-900 dark:text-white">
          Move {count} item(s)
        </h3>
        <select
          value={target}
          onChange={(e) => setTarget(e.target.value as MediaFolder)}
          className="input mb-4 w-full"
        >
          {MEDIA_FOLDERS.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </select>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="btn-ghost">
            Cancel
          </button>
          <button onClick={() => onMove(target)} disabled={pending} className="btn-primary">
            {pending ? <Loader2 className="h-4 w-4 animate-spin" /> : "Move"}
          </button>
        </div>
      </div>
    </div>
  );
}
